import { PageHero, CTABanner } from "../components/Shared";
import QualitySection from "../sections/QualitySection";
import { IMAGES } from "../data/site";

const QualityPage = () => (
  <main data-testid="quality-page">
    <PageHero
      eyebrow="Quality & Philosophy"
      title="Excellence Through Consistency."
      description="From design to dispatch, every stage of production reflects our dedication to detail, precision and perfection."
      image={IMAGES.inspection}
    />
    <QualitySection />
    <CTABanner
      title="Quality isn't checked only at the end."
      text="It is built into every stage. Experience it on your next project."
    />
  </main>
);

export default QualityPage;
